import './assets/styles/cdn.scss';
import 'vue-select/dist/vue-select.css';
import VueSelect from "vue-select";

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import routerProvider from './router'
import { checkLogin } from '@/services/auth.js'
import { initialize } from '@/services/config.js'
import ConfigurationProvider from '@/provider/configuration.js'
import TranslationProvider from '@/provider/translations.js'

async function initApp() {
  await checkLogin();
  const config = await initialize()
  TranslationProvider.setTranslations(config['app']['trans'])
  delete config['app']['trans'];
  ConfigurationProvider.setConfig(config)
  routerProvider.initialize()
  const app = createApp(App)
  app.use(createPinia())
  app.use(routerProvider.router)
  app.component("v-select", VueSelect)
  app.mount('#app')
}

initApp()
